/* GT Páginas — vídeos de influenciadoras (Rosa & Blush) */
(function () {
  if (window.gtVideosPronto) return;
  window.gtVideosPronto = true;

  var ICONE_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICONE_ESQ = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>';
  var ICONE_DIR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>';

  /* Carrega o vídeo só quando chega perto da tela e toca só o que está visível */
  var carregador = 'IntersectionObserver' in window ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (!e.isIntersecting) return;
      var v = e.target;
      if (v.dataset.src && !v.getAttribute('src')) {
        v.src = v.dataset.src;
        v.load();
      }
      carregador.unobserve(v);
    });
  }, { rootMargin: '0px 400px 300px 400px' }) : null;

  var tocador = 'IntersectionObserver' in window ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      var v = e.target;
      if (document.documentElement.classList.contains('gt-sem-rolagem')) return;
      if (e.isIntersecting && e.intersectionRatio >= 0.55) {
        if (!v.getAttribute('src') && v.dataset.src) { v.src = v.dataset.src; }
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        v.pause();
      }
    });
  }, { threshold: [0, 0.55, 1] }) : null;

  /* ---------- Modal ---------- */
  var modal, modalVideo, modalProduto, listaAtual = [], indiceAtual = 0;

  function criarModal() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'gt-vmodal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<div class="gt-vmodal__caixa">' +
        '<div class="gt-vmodal__video">' +
          '<video playsinline loop preload="auto" controlslist="nodownload noplaybackrate noremoteplayback" disablepictureinpicture disableremoteplayback draggable="false"></video>' +
          '<button type="button" class="gt-vmodal__fechar" aria-label="Fechar vídeo">' + ICONE_X + '</button>' +
        '</div>' +
        '<button type="button" class="gt-vmodal__nav gt-vmodal__nav--ant" aria-label="Vídeo anterior">' + ICONE_ESQ + '</button>' +
        '<button type="button" class="gt-vmodal__nav gt-vmodal__nav--prox" aria-label="Próximo vídeo">' + ICONE_DIR + '</button>' +
        '<div class="gt-vmodal__produto"></div>' +
      '</div>';
    document.body.appendChild(modal);
    modalVideo = modal.querySelector('video');
    modalProduto = modal.querySelector('.gt-vmodal__produto');

    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('.gt-vmodal__fechar')) fecharModal();
      else if (e.target.closest('.gt-vmodal__nav--ant')) mostrar(indiceAtual - 1);
      else if (e.target.closest('.gt-vmodal__nav--prox')) mostrar(indiceAtual + 1);
    });
    /* bloqueio: sem menu do botão direito nem arrastar o vídeo */
    modal.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    modal.addEventListener('dragstart', function (e) { e.preventDefault(); });
    modalVideo.addEventListener('click', function () {
      if (modalVideo.paused) modalVideo.play(); else modalVideo.pause();
    });
    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-aberto')) return;
      if (e.key === 'Escape') fecharModal();
      if (e.key === 'ArrowLeft') mostrar(indiceAtual - 1);
      if (e.key === 'ArrowRight') mostrar(indiceAtual + 1);
    });
  }

  function mostrar(i) {
    if (!listaAtual.length) return;
    indiceAtual = (i + listaAtual.length) % listaAtual.length;
    var card = listaAtual[indiceAtual];
    var v = card.querySelector('video');
    var src = v && (v.dataset.hd || v.dataset.src || v.getAttribute('src'));
    modalVideo.poster = (v && v.getAttribute('poster')) || '';
    modalVideo.src = src || '';
    modalVideo.muted = false;
    var p = modalVideo.play();
    if (p && p.catch) p.catch(function () { modalVideo.muted = true; modalVideo.play(); });
    var prod = card.querySelector('.gt-vcard__produto');
    modalProduto.innerHTML = prod ? prod.outerHTML : '';
    var navs = modal.querySelectorAll('.gt-vmodal__nav');
    for (var n = 0; n < navs.length; n++) navs[n].style.display = listaAtual.length > 1 ? '' : 'none';
  }

  function abrirModal(cards, i) {
    criarModal();
    listaAtual = cards;
    document.documentElement.classList.add('gt-sem-rolagem');
    document.querySelectorAll('.gt-vcard video').forEach(function (v) { v.pause(); });
    modal.classList.add('is-aberto');
    mostrar(i);
  }

  function fecharModal() {
    modal.classList.remove('is-aberto');
    modalVideo.pause();
    modalVideo.removeAttribute('src');
    modalVideo.load();
    document.documentElement.classList.remove('gt-sem-rolagem');
    if (tocador) {
      document.querySelectorAll('.gt-vcard video').forEach(function (v) { tocador.unobserve(v); tocador.observe(v); });
    }
  }

  /* ---------- Seção ---------- */
  function iniciar(secao) {
    if (secao.dataset.gtIniciado) return;
    secao.dataset.gtIniciado = '1';
    var trilho = secao.querySelector('.gt-videos__trilho');
    var cards = Array.prototype.slice.call(secao.querySelectorAll('.gt-vcard'));
    if (!trilho || !cards.length) return;

    cards.forEach(function (card, i) {
      var v = card.querySelector('video');
      if (v) {
        if (carregador) carregador.observe(v); else if (v.dataset.src) v.src = v.dataset.src;
        if (tocador) tocador.observe(v);
      }
      var midia = card.querySelector('.gt-vcard__midia');
      if (midia) {
        midia.addEventListener('contextmenu', function (e) { e.preventDefault(); });
        midia.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }
      if (midia && v) {
        midia.addEventListener('click', function () { abrirModal(cards.filter(function (c) { return c.querySelector('video'); }), cards.filter(function (c) { return c.querySelector('video'); }).indexOf(card)); });
        midia.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); midia.click(); } });
      }
    });

    var ant = secao.querySelector('[data-gt-ant]');
    var prox = secao.querySelector('[data-gt-prox]');
    function passo() { return cards[0].getBoundingClientRect().width * 2 + 28; }
    function atualizar() {
      if (!ant || !prox) return;
      ant.disabled = trilho.scrollLeft <= 4;
      prox.disabled = trilho.scrollLeft + trilho.clientWidth >= trilho.scrollWidth - 4;
    }
    if (ant) ant.addEventListener('click', function () { trilho.scrollBy({ left: -passo(), behavior: 'smooth' }); });
    if (prox) prox.addEventListener('click', function () { trilho.scrollBy({ left: passo(), behavior: 'smooth' }); });
    trilho.addEventListener('scroll', atualizar, { passive: true });
    window.addEventListener('resize', atualizar);
    atualizar();
  }

  function iniciarTodas(raiz) {
    (raiz || document).querySelectorAll('[data-gt-videos]').forEach(iniciar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciarTodas(); });
  else iniciarTodas();
  document.addEventListener('shopify:section:load', function (e) { iniciarTodas(e.target); });
})();
